import {RouterModule, Routes} from '@angular/router';
import {UserComponent} from './components/user/user.component';
import {UserListComponent} from './components/user-list/user-list.component';
import {NgModule} from '@angular/core';
import {RoleGuard} from '../../services/role.guard';
import {SettingsComponent} from './components/settings/settings.component';
import {OrdersComponent} from './components/orders/orders.component';
import {InvoicesComponent} from './components/invoices/invoices.component';
import {DiscountsComponent} from './components/discounts/discounts.component';
import {CarriersComponent} from './components/carriers/carriers.component';
import {NotesComponent} from './components/notes/notes.component';
import {InfoComponent} from './components/info/info.component';

const routes: Routes = [
  { path: 'admin', canActivate: [RoleGuard], data: {expectedRole: '5'}, children: [
      { path: 'users', component: UserListComponent},
      {
        path: 'users/:id',
        component: UserComponent,
        children: [
          { path: '', redirectTo: 'info', pathMatch: 'full' },
          { path: 'info', component: InfoComponent },
          { path: 'settings', component: SettingsComponent },
          { path: 'orders', component: OrdersComponent },
          { path: 'invoices', component: InvoicesComponent },
          { path: 'discounts', component: DiscountsComponent },
          { path: 'carriers', component: CarriersComponent },
          { path: 'notes', component: NotesComponent },
        ]
      }
    ]
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class UsersRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/modules/users/users-routing.module.ts